module.exports = "/_next/static/images/montana-ee1b59b625911a27c6cc6da2edd0be94.svg";